var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 16,
    fill: "#d2d2d2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 14.344,
    fill: "#d2d2d2",
    fillOpacity: 1,
    transform: "rotate(45 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 12.531,
    fill: "#d2d2d2",
    fillOpacity: 1,
    transform: "rotate(90 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 10.75,
    fill: "#d2d2d2",
    fillOpacity: 1,
    transform: "rotate(135 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 10.063,
    fill: "#d2d2d2",
    fillOpacity: 1,
    transform: "rotate(180 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 8.063,
    fill: "#d2d2d2",
    fillOpacity: 1,
    transform: "rotate(225 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 6.438,
    fill: "#d2d2d2",
    fillOpacity: 1,
    transform: "rotate(270 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 5.375,
    fill: "#d2d2d2",
    fillOpacity: 1,
    transform: "rotate(315 64 64)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64",
    calcMode: "discrete",
    dur: "720ms",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.1236c219dae86da3f4dbbc6bd4ca731b.svg";
export { ForwardRef as ReactComponent };